import { render, staticRenderFns } from "./impressum.vue?vue&type=template&id=08b45b74&scoped=true&"
import script from "./impressum.vue?vue&type=script&lang=js&"
export * from "./impressum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b45b74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Ampps/www/mwst-rechner-pwa/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VResponsive } from 'vuetify/lib'
installComponents(component, {VCardText,VContainer,VDivider,VFlex,VLayout,VProgressLinear,VResponsive})
